import { z } from 'zod';
/**
 * Audit jurnali — "kim nima qildi" savoliga javob.
 *
 * MANBA UCHTA, chunki tarix uch jadvalda yotadi va ularning har biri
 * o'z domenining haqiqat manbai:
 *
 * - `audit_log` — pul va ruxsatga tegadigan amallar
 * - `price_history` — narx o'zgarishi (narx trendi uchun ham kerak)
 * - `shipment_status_history` — status o'tishlari
 *
 * Faqat `audit_log` ni ko'rsatadigan jurnal "narx o'zgarmagan" degan
 * YOLG'ON javob berardi. Shuning uchun uchalasi o'qishda birlashtiriladi,
 * ikki joyga yozish orqali emas: yozuvchi qo'shimcha qatorni unutsa,
 * jurnal jimgina to'liqsiz bo'lib qolardi.
 */
export const AuditSourceSchema = z.enum(['AUDIT', 'PRICE', 'STATUS']);
/**
 * Amal kalitlari — YAGONA ro'yxat.
 *
 * `SETTING_DEFINITIONS` bilan bir xil yondashuv: servis erkin matn
 * yozsa, `payment.confirmed` va `payment.confirm` yonma-yon paydo
 * bo'lardi va filtr ularning birini ko'rmasdi.
 */
export const AUDIT_ACTIONS = [
    'consignment.created',
    'consignment.shipments_attached',
    'consignment.status_changed',
    'consignment.updated',
    'import.applied',
    'import.validated',
    'order.note_updated',
    'payment.confirmed',
    'payment.recorded',
    'payment.refunded',
    'payment.rejected',
    'product.archived',
    'product.bulk_activated',
    'setting.changed',
    'shipment.courier_assigned',
    'status.config_changed',
    'user.role_changed',
];
export const AuditActionSchema = z.enum(AUDIT_ACTIONS);
/** Sintetik amallar: ular `audit_log` da emas, domen jadvalidan keladi. */
export const AUDIT_SYNTHETIC_ACTIONS = [
    'product.price_changed',
    'shipment.status_changed',
];
export const AuditEntrySchema = z.object({
    id: z.string(),
    source: AuditSourceSchema,
    action: z.string(),
    entity: z.string(),
    entityId: z.string().nullable(),
    actorId: z.string().uuid().nullable(),
    /// `null` — tizim bajargan (avtomatik o'tish, navbat).
    actorName: z.string().nullable(),
    /// Nima o'zgardi. Shakl amalga qarab boshqacha — klient uni ko'rsatadi, o'qimaydi.
    changes: z.record(z.unknown()).nullable(),
    ip: z.string().nullable(),
    createdAt: z.string(),
});
export const ListAuditQuerySchema = z
    .object({
    entity: z.string().max(48).optional(),
    entityId: z.string().max(64).optional(),
    actorId: z.string().uuid().optional(),
    action: z.string().max(64).optional(),
    from: z.string().datetime().optional(),
    to: z.string().datetime().optional(),
    /// `createdAt|id` — oddiy `id` kursori uch manbani birlashtira olmaydi.
    cursor: z.string().max(120).optional(),
    limit: z.coerce.number().int().min(1).max(100).default(50),
})
    .strict();
export const AuditPageSchema = z.object({
    items: z.array(AuditEntrySchema),
    nextCursor: z.string().nullable(),
});
//# sourceMappingURL=audit.js.map